import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import './composables/useLandingTheme'
import { i18n } from './lib/i18n'
import { initPreline } from './lib/preline'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)

/**
 * Last line of defence for render errors: without this a thrown error in one
 * component leaves a blank page with no explanation.
 */
app.config.errorHandler = (error, _instance, info) => {
  console.error('[app] unhandled error', info, error)
}

app.mount('#app')

void router.isReady().then(() => initPreline())
